import React from 'react'

function ReservationHero() {
  return (
    <div className="reservation-hero">
      <h1 className="hero-title">Reservation</h1>
    </div>
  );
}

export default ReservationHero